import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** マスタ共通の出力順のキー */
enum MstOrderItem {
  code = '1',
  name = '2',
  spareName01 = '3',
  spareName02 = '4',
}

const nameConfig = {
  code: new Map([
    [Locale.ja, 'コード'],
    [Locale.en, 'Code'],
  ]),
  name: new Map([
    [Locale.ja, '名称'],
    [Locale.en, 'Name'],
  ]),
  spareName01: new Map([
    [Locale.ja, '予備名称1'],
    [Locale.en, 'Spare Name One'],
  ]),
  spareName02: new Map([
    [Locale.ja, '予備名称2'],
    [Locale.en, 'Spare Name Two'],
  ]),
};

const toDisplay = enumToName(MstOrderItem, nameConfig);
const toDisplayWithPrefix = enumToName(MstOrderItem, nameConfig, { prefix: true });

export const mstOrderItem = {
  enum: MstOrderItem,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { MstOrderItem };
